var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 133.478,
    y: 176.697,
    width: 206.304,
    height: 16.101
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,53.771c9.99,0,18.118-8.127,18.118-18.117c0-9.988-8.128-18.113-18.118-18.113s-18.118,8.125-18.118,18.113 C237.882,45.643,246.011,53.771,256,53.771z M256,33.642c1.112,0,2.017,0.903,2.017,2.012c0,1.111-0.905,2.016-2.017,2.016 s-2.017-0.905-2.017-2.016C253.983,34.545,254.888,33.642,256,33.642z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.346,83.835 209.346,83.835 302.65,83.835 302.65,67.734 209.346,67.734 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.478,
    y: 246.432,
    width: 206.304,
    height: 16.101
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.478,
    y: 141.83,
    width: 241.17,
    height: 16.101
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.918,60.533h-56.923c-4.016-11.743-15.155-20.215-28.244-20.215h-32.407c0.206-1.546,0.311-3.105,0.311-4.665 C291.656,15.994,275.661,0,256,0s-35.656,15.994-35.656,35.654c0,1.56,0.105,3.118,0.311,4.665h-32.411 c-13.086,0-24.225,8.471-28.242,20.215h-56.921c-20.463,0-37.108,16.647-37.108,37.108v377.252 c0,20.461,16.647,37.106,37.108,37.106h305.837c20.463,0,37.108-16.646,37.108-37.106V97.642 C446.028,77.179,429.381,60.533,408.918,60.533z M174.502,70.16c0-7.577,6.165-13.741,13.743-13.741h43.266 c2.812,0,5.422-1.467,6.882-3.872c1.459-2.403,1.559-5.396,0.261-7.892c-1.464-2.819-2.208-5.847-2.208-9.003 c0-10.781,8.772-19.552,19.555-19.552c10.782,0,19.554,8.771,19.554,19.552c0,3.155-0.743,6.183-2.209,9 c-1.299,2.496-1.2,5.487,0.26,7.894c1.459,2.404,4.068,3.873,6.882,3.873h43.264c7.579,0,13.745,6.164,13.745,13.741v24.273 H174.502V70.16z M166.451,110.535h179.096c4.447,0,8.051-3.603,8.051-8.051v-0.498h45.931V454.38h-287.06V101.987H158.4v0.498 C158.4,106.931,162.005,110.535,166.451,110.535z M408.919,495.899H103.082c-11.583,0-21.007-9.422-21.007-21.005V97.642 c0-11.583,9.424-21.007,21.007-21.007H158.4v9.251h-53.983c-4.447,0-8.051,3.603-8.051,8.051v368.494 c0,4.447,3.603,8.051,8.051,8.051h303.162c4.447,0,8.051-3.603,8.051-8.051V93.936c0-4.447-3.603-8.051-8.051-8.051h-53.981 v-9.251h55.321c11.583,0,21.007,9.424,21.007,21.007v377.252h0.001C429.926,486.476,420.503,495.899,408.919,495.899z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.478,
    y: 316.166,
    width: 206.304,
    height: 16.101
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.478,
    y: 211.565,
    width: 241.17,
    height: 16.101
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.478,
    y: 351.033,
    width: 241.17,
    height: 16.101
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.478,
    y: 281.299,
    width: 241.17,
    height: 16.101
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.f4423adebbc38ee141f16fe737609ec9.svg";
export { ForwardRef as ReactComponent };